import { render, staticRenderFns } from "./PageAvaliacaoServidor.vue?vue&type=template&id=4d6cf263&scoped=true"
import script from "./PageAvaliacaoServidor.vue?vue&type=script&lang=js"
export * from "./PageAvaliacaoServidor.vue?vue&type=script&lang=js"
import style0 from "./PageAvaliacaoServidor.vue?vue&type=style&index=0&id=4d6cf263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6cf263",
  null
  
)

export default component.exports